import { CSSProperties, Children, PropsWithChildren, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './ActionBar.module.css';

export const ACTION_BAR_HEIGHT = 70;

export const ActionBar = forwardRef<
  HTMLDivElement | null,
  PropsWithChildren<{ topOffset?: number; className?: string }>
>(({ topOffset, children, className }, ref) => {
  const slots = Array.isArray(children) ? children : [children];
  const columns = slots.length;
  const hasTrailingItem = Children.toArray(slots[columns - 1]).length > 0;
  const leadingColumns =
    columns - 1 !== 0 ? `repeat(${columns - 1}, max-content)` : '';

  return (
    <div
      data-component="ActionBar"
      className={styles.root}
      ref={ref}
      style={
        {
          '--action-bar-top-offset': `${topOffset || 0}px`,
          '--action-bar-height': `${ACTION_BAR_HEIGHT}px`,
        } as CSSProperties
      }
    >
      <div
        className={classNames(
          styles.content,
          { [styles.trailingItemEnd]: hasTrailingItem },
          className,
        )}
        style={
          {
            '--action-bar-columns': `${leadingColumns} 1fr max-content`,
          } as CSSProperties
        }
      >
        {children}
      </div>
    </div>
  );
});
ActionBar.displayName = 'ActionBar';
